import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useSession } from '@/entities/session'
import { autoRedirectToLogin } from '@/shared/api'
import { runtimeConfig } from '@/shared/config'

export const Route = createFileRoute('/')({
  component: IndexRedirect,
})

// Корень — развилка по контуру сессии: сотрудник → встречи команды, заказчик →
// свои созвоны. Своей формы логина у telemost нет, поэтому без сессии уходим на
// единый вход хаба сразу — брендированный экран с кнопкой был бы лишним шагом.
// Автопереход рвётся после первой попытки (вернулись без сессии) и не делается
// в mock-режиме → тогда /login.
function IndexRedirect() {
  const { isLoading, isAuthenticated, session } = useSession()
  const navigate = useNavigate()
  useEffect(() => {
    if (isLoading) return
    if (isAuthenticated) {
      void navigate({
        to: session?.kind === 'customer' ? '/my/meetings' : '/meetings',
        replace: true,
      })
      return
    }
    if (runtimeConfig.API_MODE !== 'mock' && autoRedirectToLogin('/meetings')) return
    void navigate({ to: '/login', search: {}, replace: true })
  }, [isLoading, isAuthenticated, session, navigate])
  return null
}
